export default "__VITE_ASSET__xVD0OkkwZ8C1QjBKZQaTkw__"